// // // import React, { useEffect, useState } from "react";
// // // import {
// // //   Box,
// // //   Typography,
// // //   Button,
// // //   Pagination,
// // //   PaginationItem,
// // //   CircularProgress,
// // // } from "@mui/material";
// // // import { useNavigate } from "react-router-dom";
// // // import { useApi } from "../api/useApi";
// // // // import GradientLayout from "../components/GradientLayout";
// // // import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// // // import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// // // const ITEMS_PER_PAGE = 6;

// // // export default function InstructionsCard() {
// // //   const [page, setPage] = useState(1);
// // //   const [instructionsData, setInstructionsData] = useState([]);
// // //   const { loading, request } = useApi();
// // //   const navigate = useNavigate();
// // //   const pageCount = Math.ceil(instructionsData.length / ITEMS_PER_PAGE);

// // //   useEffect(() => {
// // //     async function fetchInstructions() {
// // //       const data = await request({ url: "/tasks" });
// // //       setInstructionsData(data);
// // //     }
// // //     fetchInstructions();
// // //   }, []);

// // //   const handlePageChange = (_, value) => setPage(value);

// // //   const currentItems = instructionsData.slice(
// // //     (page - 1) * ITEMS_PER_PAGE,
// // //     page * ITEMS_PER_PAGE
// // //   );

// // //   return (

// // //   <Box
// // //     sx={{
// // //       position: "relative",
// // //       zIndex: 2,
// // //       width: "100%",
// // //       height: "100vh",
// // //       display: "flex",
// // //       justifyContent: { xs: "center", md: "flex-start" }, // ✅ Left align on medium+
// // //       alignItems: "center",
// // //       overflow: "hidden",
// // //       background: "#fff",
// // //       px: { xs: "1rem", sm: "2rem", md: "3rem", lg: "2rem",xl:'3rem' }, // responsive side padding
// // //     }}
// // //   >
// // //     {/* Loader */}
// // //     {loading && instructionsData.length === 0 ? (
// // //       <Box
// // //         sx={{
// // //           display: "flex",
// // //           justifyContent: { xs: "center", md: "flex-start" },
// // //           alignItems: "center",
// // //           width: "100%",
// // //           minHeight: "60vh",
// // //         }}
// // //       >
// // //         <CircularProgress size={50} sx={{ color: "#0F62FE" }} />
// // //       </Box>
// // //     ) : (
// // //       /* Main Instruction Card */
// // //       <Box
// // //         sx={{
// // //           display: "flex",
// // //           flexDirection: "column",
// // //           width: {
// // //             xs: "90vw",
// // //             sm: "85vw",
// // //             md: "70vw",
// // //             lg: "73vw",
// // //             xl: "80vw",
// // //           },
// // //           ml: { xs: 0, md: "1rem", lg: "-0.5rem" }, // ✅ shift card toward left
// // //           height: {
// // //             xs: "85vh",
// // //             sm: "82vh",
// // //             md: "80vh",
// // //             lg: "75vh",
// // //             xl: "82vh",
// // //           },
// // //           p: { xs: "1rem", sm: "1.5rem", md: "2rem" },
// // //           borderRadius: "1.25rem",
// // //           background:
// // //             "linear-gradient(180deg, rgba(255,255,255,0.02), rgba(0,0,0,0.12))",
// // //           border: "1px solid rgba(255,255,255,0.18)",
// // //           boxShadow:
// // //             "0 8px 30px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.03)",
// // //           backdropFilter: "blur(8px)",
// // //           overflow: "hidden",
// // //           zIndex: 4,
// // //         }}
// // //       >
// // //         {/* Title */}
// // //         <Typography
// // //           sx={{
// // //             color: "#3C4044",
// // //             fontFeatureSettings: "'liga' off, 'clig' off",
// // //             // fontFamily: "Akkurat-Bold",
// // //             fontSize: "1rem",
// // //             fontStyle: "normal",
// // //             fontWeight: 400,
// // //             lineHeight: "2",
// // //           }}
// // //         >
// // //           Instructions
// // //         </Typography>

// // //         {/* Instruction Cards */}
// // //         <Box
// // //           sx={{
// // //             display: "flex",
// // //             flexDirection: "column",
// // //             gap: "1rem",
// // //             width: "100%",
// // //             flex: 1,
// // //             overflowY: "auto",
// // //             "&::-webkit-scrollbar": {
// // //               width: "3px",
// // //             },
// // //             "&::-webkit-scrollbar-thumb": {
// // //               background: "rgba(255,255,255,0.8)",
// // //               borderRadius: "1rem",
// // //             },
// // //             "&::-webkit-scrollbar-thumb:hover": {
// // //               background: "rgba(255,255,255,1)",
// // //             },
// // //           }}
// // //         >
// // //           {currentItems.map((item, index) => (
// // //             <Box
// // //               key={index}
// // //               sx={{
// // //                 p: "1rem",
// // //                 borderRadius: "1rem",
// // //                 background: "rgba(255, 255, 255, 0.70)",
// // //                 boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
// // //               }}
// // //             >
// // //               <Typography
// // //                 sx={{
// // //                   color: "#3C4044",
// // //                   // fontFamily: "Akkurat",
// // //                   fontSize: { xs: "0.8rem", sm: "0.9rem" },
// // //                   mb: "0.25rem",
// // //                 }}
// // //               >
// // //                 {item.title}
// // //               </Typography>
// // //               <Typography
// // //                 sx={{
// // //                   color: "#000",
// // //                   // fontFamily: "Akkurat",
// // //                   fontSize: { xs: "0.7rem", sm: "0.8rem" },
// // //                   lineHeight: 1.4,
// // //                 }}
// // //               >
// // //                 {item.instruction}
// // //               </Typography>
// // //             </Box>
// // //           ))}
// // //         </Box>

// // //         {/* Pagination + Go Back (Responsive Layout) */}
// // // <Box
// // //   sx={{
// // //     display: "flex",
// // //     flexDirection: "row",
// // //     alignItems: "center",
// // //     justifyContent: "space-between", // ✅ Spread pagination (center) and button (right)
// // //     width: "100%",
// // //     mt: 1,
// // //   }}
// // // >
// // //   {/* Pagination Wrapper to center it */}
// // //   <Box
// // //     sx={{
// // //       flexGrow: 1,
// // //       display: "flex",
// // //       marginLeft:15,
// // //       justifyContent: "center", // ✅ Centers pagination in the middle of container
// // //     }}
// // //   >
// // //     <Pagination
// // //       count={pageCount}
// // //       page={page}
// // //       onChange={handlePageChange}
// // //       sx={{
// // //         "& .MuiPaginationItem-root": {
// // //           color: "#000",
// // //           fontWeight: 500,
// // //         },
// // //         "& .Mui-selected": {
// // //           backgroundColor: "transparent !important",
// // //           color: "#000 !important",
// // //           fontWeight: 600,
// // //           position: "relative",
// // //           "&::after": {
// // //             content: '""',
// // //             position: "absolute",
// // //             bottom: "-4px",
// // //             left: "50%",
// // //             transform: "translateX(-50%)",
// // //             width: "12px",
// // //             borderBottom: "3px solid #000",
// // //           },
// // //         },
// // //       }}
// // //     />
// // //   </Box>

// // //   {/* Go Back Button */}
// // //   <Button
// // //     variant="contained"
// // //     sx={{
// // //       width: { xs: "8rem", sm: "9rem", md: "10rem" },
// // //       height: { xs: "2.3rem", sm: "2.5rem" },
// // //       borderRadius: "1.75rem",
// // //       backgroundColor: "#0036DD",
// // //       color: "#fff",
// // //       textTransform: "none",
// // //       fontSize: { xs: "0.75rem", sm: "0.85rem" },
// // //       "&:hover": {
// // //         backgroundColor: "#0052cc",
// // //       },
// // //     }}
// // //     onClick={() => navigate(-1)}
// // //   >
// // //     Go back
// // //   </Button>
// // // </Box>

// // //       </Box>
// // //     )}
// // //   </Box>

// // //   );
// // // }

// // import React, { useEffect, useState } from "react";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Pagination,
// //   CircularProgress,
// // } from "@mui/material";
// // import { useNavigate } from "react-router-dom";
// // import { useApi } from "../api/useApi";

// // const ITEMS_PER_PAGE = 6;

// // export default function InstructionsCard() {
// //   const [page, setPage] = useState(1);
// //   const [instructionsData, setInstructionsData] = useState([]);
// //   const { loading, request } = useApi();
// //   const navigate = useNavigate();
// //   const pageCount = Math.ceil(instructionsData.length / ITEMS_PER_PAGE);

// //   useEffect(() => {
// //     async function fetchInstructions() {
// //       const data = await request({ url: "/tasks" });
// //       setInstructionsData(data);
// //     }
// //     fetchInstructions();
// //   }, []);

// //   const handlePageChange = (_, value) => setPage(value);

// //   const currentItems = instructionsData.slice(
// //     (page - 1) * ITEMS_PER_PAGE,
// //     page * ITEMS_PER_PAGE
// //   );

// //   return (
// //     <Box
// //       sx={{
// //         position: "relative",
// //         zIndex: 1,
// //         width: "100%",
// //         minHeight: "100vh",
// //         display: "flex",
// //         justifyContent: "center",
// //         alignItems: "flex-start",
// //         overflow: "hidden",
// //         background: "#fff",
// //         pt: { xs: "1rem", md: "2.5rem" },
// //       }}
// //     >
// //       {/* Loader */}
// //       {loading && instructionsData.length === 0 ? (
// //         <Box
// //           sx={{
// //             display: "flex",
// //             justifyContent: { xs: "center", md: "flex-start" },
// //             alignItems: "center",
// //             width: "100%",
// //             minHeight: "60vh",
// //           }}
// //         >
// //           <CircularProgress size={50} sx={{ color: "#0F62FE" }} />
// //         </Box>
// //       ) : (
// //         /* Main Card */
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             width: {
// //               xs: "92vw",
// //               sm: "88vw",
// //               md: "70vw",
// //               lg: "75vw",
// //               xl: "75vw",
// //             },
// //             height: {
// //               xs: "85vh",
// //               sm: "82vh",
// //               md: "80vh",
// //               lg: "78vh",
// //               xl: "82vh",
// //             },
// //             p: { xs: "1rem",
// //               sm: "1rem",
// //               md: "1rem",
// //               lg: "2rem 1rem",
// //               xl: "1rem", },
// //             borderRadius: "1.25rem",
// //             background: "#FFFFFF",
// //             border: "1px solid #DADADA",
// //             boxShadow: "0px 2px 8px rgba(0,0,0,0.12)",
// //             overflow: "hidden",
// //           }}
// //         >
// //           {/* Heading */}
// //          <Box
// //   sx={{
// //     width: "95%",
// //      padding: "0.75rem  1.5rem",
// //     borderBottom: "1px solid #D4D9E2",
// //     background: "#EDF0FD",
// //     mb: "1rem",
// //     borderRadius: "0.75rem",
// //   }}
// // >
// //   <Typography
// //     sx={{
// //       color: "#0036DD",
// //       fontSize: "1.05rem",
// //       fontWeight: 400,
// //       fontFamily:"Akkurat-Bold",
// //       pl:1
// //     }}
// //   >
// //     Instructions
// //   </Typography>
// // </Box>

// //           {/* List Items */}
// //           {/* <Box
// //             sx={{
// //               display: "flex",
// //               flexDirection: "column",
// //               gap: "0.75rem",
// //               width: "100%",
// //               flex: 1,
// //               overflowY: "auto",

// //               "&::-webkit-scrollbar": 'none',
// //               "&::-webkit-scrollbar-thumb": {
// //                 background: "rgba(0,0,0,0.3)",
// //                 borderRadius: "1rem",
// //               },
// //             }}
// //           > */}
// //    <Box
// //   sx={{
// //     display: "flex",
// //     flexDirection: "column",
// //     gap: "1rem",
// //     width: "100%",
// //     flex: 1,
// //     overflowY: "scroll",

// //     pr: "0.3rem",   // 👉 FIX: Ensures the right border doesn’t get cut off

// //     /* Hide scrollbar for Chrome, Edge, Safari */
// //     "&::-webkit-scrollbar": { display: "none" },

// //     /* Hide scrollbar for Firefox */
// //     scrollbarWidth: "none",

// //     /* Hide scrollbar for IE/Edge (pre-Chromium) */
// //     msOverflowStyle: "none",
// //   }}
// // >

// //             {currentItems.map((item, index) => (
// //               <Box
// //                 key={index}
// //                 sx={{
// //                   width: "100%",
// //                   borderRadius: "0.75rem",
// //                   border: "1px solid #D4D9E2",
// //                   background: "#FFFFFF",
// //                   padding: "0.75rem  1rem",
// //                   display: "flex",
// //                   alignItems: "center",
// //                   boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
// //                   "&:hover": { background: "#F7F9FF" },
// //                 }}
// //               >
// //                 <Typography
// //                   sx={{
// //                     color: "#000",
// //                     fontSize: "0.75rem",
// //                     fontFamily:"Akkurat",
// //                     lineHeight: "normal",
// //                     pl:1
// //                   }}
// //                 >
// //                   {item.instruction}
// //                 </Typography>
// //               </Box>
// //             ))}
// //           </Box>

// //           {/* Pagination + Go back */}
// //           <Box
// //             sx={{
// //               display: "flex",
// //               flexDirection: "row",
// //               alignItems: "center",
// //               justifyContent: "space-between",
// //               width: "100%",
// //               mt: 1,
// //             }}
// //           >
// //             <Box sx={{ flexGrow: 1, display: "flex",flexDirection:'column', justifyContent: "center",alignItems:'center',gap:2 }}>
// //               <Pagination
// //                 count={pageCount}
// //                 page={page}
// //                 onChange={handlePageChange}
// //                 sx={{
// //                   "& .MuiPaginationItem-root": { color: "#000", fontWeight: 400 },
// //                   "& .Mui-selected": {
// //                     backgroundColor: "transparent !important",
// //                     color: "#000 !important",
// //                     fontWeight: 500,
// //                     position: "relative",
// //                     "&::after": {
// //                       content: '""',
// //                       position: "absolute",
// //                       bottom: "-4px",
// //                       left: "50%",
// //                       transform: "translateX(-50%)",
// //                       width: "12px",
// //                       borderBottom: "3px solid #000",
// //                     },
// //                   },
// //                 }}
// //               />

// //             <Button
// //               variant="contained"
// //               sx={{
// //                 width: { xs: "6rem", sm: "7rem", md: "7.5rem" },
// //                 height: { xs: "2.3rem", sm: "2.25rem" },
// //                 borderRadius: "1.75rem",
// //                 background: "none",
// //                 color: "#1F2D5C",
// //                 border:'1px solid #1F2D5C',
// //                 textTransform: "none",
// //                 fontFamily:"Akkurat",
// //                 fontWeight:400,
// //                 fontSize: { xs: "0.75rem", sm: "0.85rem" },
// //                 // "&:hover": { backgroundColor: "#0052cc" },
// //               }}
// //               onClick={() => navigate(-1)}
// //             >
// //               Back
// //             </Button>
// //             </Box>
// //           </Box>
// //         </Box>
// //       )}
// //     </Box>
// //   );
// // }

// // import React, { useEffect, useState } from "react";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Pagination,
// //   PaginationItem,
// //   CircularProgress,
// // } from "@mui/material";
// // import { useNavigate } from "react-router-dom";
// // import { useApi } from "../api/useApi";
// // // import GradientLayout from "../components/GradientLayout";
// // import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// // import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

// // const ITEMS_PER_PAGE = 6;

// // export default function InstructionsCard() {
// //   const [page, setPage] = useState(1);
// //   const [instructionsData, setInstructionsData] = useState([]);
// //   const { loading, request } = useApi();
// //   const navigate = useNavigate();
// //   const pageCount = Math.ceil(instructionsData.length / ITEMS_PER_PAGE);

// //   useEffect(() => {
// //     async function fetchInstructions() {
// //       const data = await request({ url: "/tasks" });
// //       setInstructionsData(data);
// //     }
// //     fetchInstructions();
// //   }, []);

// //   const handlePageChange = (_, value) => setPage(value);

// //   const currentItems = instructionsData.slice(
// //     (page - 1) * ITEMS_PER_PAGE,
// //     page * ITEMS_PER_PAGE
// //   );

// //   return (

// //   <Box
// //     sx={{
// //       position: "relative",
// //       zIndex: 2,
// //       width: "100%",
// //       height: "100vh",
// //       display: "flex",
// //       justifyContent: { xs: "center", md: "flex-start" }, // ✅ Left align on medium+
// //       alignItems: "center",
// //       overflow: "hidden",
// //       background: "#fff",
// //       px: { xs: "1rem", sm: "2rem", md: "3rem", lg: "2rem",xl:'3rem' }, // responsive side padding
// //     }}
// //   >
// //     {/* Loader */}
// //     {loading && instructionsData.length === 0 ? (
// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: { xs: "center", md: "flex-start" },
// //           alignItems: "center",
// //           width: "100%",
// //           minHeight: "60vh",
// //         }}
// //       >
// //         <CircularProgress size={50} sx={{ color: "#0F62FE" }} />
// //       </Box>
// //     ) : (
// //       /* Main Instruction Card */
// //       <Box
// //         sx={{
// //           display: "flex",
// //           flexDirection: "column",
// //           width: {
// //             xs: "90vw",
// //             sm: "85vw",
// //             md: "70vw",
// //             lg: "73vw",
// //             xl: "80vw",
// //           },
// //           ml: { xs: 0, md: "1rem", lg: "-0.5rem" }, // ✅ shift card toward left
// //           height: {
// //             xs: "85vh",
// //             sm: "82vh",
// //             md: "80vh",
// //             lg: "75vh",
// //             xl: "82vh",
// //           },
// //           p: { xs: "1rem", sm: "1.5rem", md: "2rem" },
// //           borderRadius: "1.25rem",
// //           background:
// //             "linear-gradient(180deg, rgba(255,255,255,0.02), rgba(0,0,0,0.12))",
// //           border: "1px solid rgba(255,255,255,0.18)",
// //           boxShadow:
// //             "0 8px 30px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.03)",
// //           backdropFilter: "blur(8px)",
// //           overflow: "hidden",
// //           zIndex: 4,
// //         }}
// //       >
// //         {/* Title */}
// //         <Typography
// //           sx={{
// //             color: "#3C4044",
// //             fontFeatureSettings: "'liga' off, 'clig' off",
// //             // fontFamily: "Akkurat-Bold",
// //             fontSize: "1rem",
// //             fontStyle: "normal",
// //             fontWeight: 400,
// //             lineHeight: "2",
// //           }}
// //         >
// //           Instructions
// //         </Typography>

// //         {/* Instruction Cards */}
// //         <Box
// //           sx={{
// //             display: "flex",
// //             flexDirection: "column",
// //             gap: "1rem",
// //             width: "100%",
// //             flex: 1,
// //             overflowY: "auto",
// //             "&::-webkit-scrollbar": {
// //               width: "3px",
// //             },
// //             "&::-webkit-scrollbar-thumb": {
// //               background: "rgba(255,255,255,0.8)",
// //               borderRadius: "1rem",
// //             },
// //             "&::-webkit-scrollbar-thumb:hover": {
// //               background: "rgba(255,255,255,1)",
// //             },
// //           }}
// //         >
// //           {currentItems.map((item, index) => (
// //             <Box
// //               key={index}
// //               sx={{
// //                 p: "1rem",
// //                 borderRadius: "1rem",
// //                 background: "rgba(255, 255, 255, 0.70)",
// //                 boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
// //               }}
// //             >
// //               <Typography
// //                 sx={{
// //                   color: "#3C4044",
// //                   // fontFamily: "Akkurat",
// //                   fontSize: { xs: "0.8rem", sm: "0.9rem" },
// //                   mb: "0.25rem",
// //                 }}
// //               >
// //                 {item.title}
// //               </Typography>
// //               <Typography
// //                 sx={{
// //                   color: "#000",
// //                   // fontFamily: "Akkurat",
// //                   fontSize: { xs: "0.7rem", sm: "0.8rem" },
// //                   lineHeight: 1.4,
// //                 }}
// //               >
// //                 {item.instruction}
// //               </Typography>
// //             </Box>
// //           ))}
// //         </Box>

// //         {/* Pagination + Go Back (Responsive Layout) */}
// // <Box
// //   sx={{
// //     display: "flex",
// //     flexDirection: "row",
// //     alignItems: "center",
// //     justifyContent: "space-between", // ✅ Spread pagination (center) and button (right)
// //     width: "100%",
// //     mt: 1,
// //   }}
// // >
// //   {/* Pagination Wrapper to center it */}
// //   <Box
// //     sx={{
// //       flexGrow: 1,
// //       display: "flex",
// //       marginLeft:15,
// //       justifyContent: "center", // ✅ Centers pagination in the middle of container
// //     }}
// //   >
// //     <Pagination
// //       count={pageCount}
// //       page={page}
// //       onChange={handlePageChange}
// //       sx={{
// //         "& .MuiPaginationItem-root": {
// //           color: "#000",
// //           fontWeight: 500,
// //         },
// //         "& .Mui-selected": {
// //           backgroundColor: "transparent !important",
// //           color: "#000 !important",
// //           fontWeight: 600,
// //           position: "relative",
// //           "&::after": {
// //             content: '""',
// //             position: "absolute",
// //             bottom: "-4px",
// //             left: "50%",
// //             transform: "translateX(-50%)",
// //             width: "12px",
// //             borderBottom: "3px solid #000",
// //           },
// //         },
// //       }}
// //     />
// //   </Box>

// //   {/* Go Back Button */}
// //   <Button
// //     variant="contained"
// //     sx={{
// //       width: { xs: "8rem", sm: "9rem", md: "10rem" },
// //       height: { xs: "2.3rem", sm: "2.5rem" },
// //       borderRadius: "1.75rem",
// //       backgroundColor: "#0036DD",
// //       color: "#fff",
// //       textTransform: "none",
// //       fontSize: { xs: "0.75rem", sm: "0.85rem" },
// //       "&:hover": {
// //         backgroundColor: "#0052cc",
// //       },
// //     }}
// //     onClick={() => navigate(-1)}
// //   >
// //     Go back
// //   </Button>
// // </Box>

// //       </Box>
// //     )}
// //   </Box>

// //   );
// // }

// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Pagination,
//   CircularProgress,
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { useApi } from "../api/useApi";

// const ITEMS_PER_PAGE = 6;

// export default function InstructionsCard() {
//   const [page, setPage] = useState(1);
//   const [instructionsData, setInstructionsData] = useState([]);
//   const { loading, request } = useApi();
//   const navigate = useNavigate();
//   const pageCount = Math.ceil(instructionsData.length / ITEMS_PER_PAGE);

//   useEffect(() => {
//     async function fetchInstructions() {
//       const data = await request({ url: "/tasks" });
//       setInstructionsData(data);
//     }
//     fetchInstructions();
//   }, []);

//   const handlePageChange = (_, value) => setPage(value);

//   const currentItems = instructionsData.slice(
//     (page - 1) * ITEMS_PER_PAGE,
//     page * ITEMS_PER_PAGE
//   );

//   return (
//     <Box
//       sx={{
//         position: "relative",
//         zIndex: 1,
//         width: "100%",
//         minHeight: "100vh",
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "flex-start",
//         overflow: "hidden",
//         background: "#fff",
//         pt: { xs: "1rem", md: "2.5rem" },
//       }}
//     >
//       {/* Loader */}
//       {loading && instructionsData.length === 0 ? (
//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: { xs: "center", md: "flex-start" },
//             alignItems: "center",
//             width: "100%",
//             minHeight: "60vh",
//           }}
//         >
//           <CircularProgress size={50} sx={{ color: "#0F62FE" }} />
//         </Box>
//       ) : (
//         /* Main Card */
//         <Box
//           sx={{
//             display: "flex",
//             flexDirection: "column",
//             width: {
//               xs: "92vw",
//               sm: "88vw",
//               md: "70vw",
//               lg: "75vw",
//               xl: "75vw",
//             },
//             height: {
//               xs: "85vh",
//               sm: "82vh",
//               md: "80vh",
//               lg: "78vh",
//               xl: "82vh",
//             },
//             p: { xs: "1rem",
//               sm: "1rem",
//               md: "1rem",
//               lg: "2rem 1rem",
//               xl: "1rem", },
//             borderRadius: "1.25rem",
//             background: "#FFFFFF",
//             border: "1px solid #DADADA",
//             boxShadow: "0px 2px 8px rgba(0,0,0,0.12)",
//             overflow: "hidden",
//           }}
//         >
//           {/* Heading */}
//          <Box
//   sx={{
//     width: "95%",
//      padding: "0.75rem  1.5rem",
//     borderBottom: "1px solid #D4D9E2",
//     background: "#EDF0FD",
//     mb: "1rem",
//     borderRadius: "0.75rem",
//   }}
// >
//   <Typography
//     sx={{
//       color: "#0036DD",
//       fontSize: "1.05rem",
//       fontWeight: 400,
//       fontFamily:"Akkurat-Bold",
//       pl:1
//     }}
//   >
//     Instructions
//   </Typography>
// </Box>

// {/* Scrollable Area */}
// <Box
//   sx={{
//     display: "flex",
//     flexDirection: "column",
//     gap: "1rem",
//     width: "100%",
//     flex: 1,
//     overflowY: "scroll",
//     pr: "0.3rem",
//     "&::-webkit-scrollbar": { display: "none" },
//     scrollbarWidth: "none",
//     msOverflowStyle: "none",
//   }}
// >

//   {/* Maturity Levels Box */}
//   {page === 1 && (
// <Box
//   sx={{
//     display: "flex",
//     flexDirection: "column",
//     gap: "1rem",
//     padding: { xs: "0.75rem", md: "1rem" },
//     borderRadius: "0.5rem",
//     border: "1px solid #D5DBDE",
//     background: "#FFF",
//     // "&:hover": { background: "#F7F9FF" },
//   }}
// >
//   <Typography
//     sx={{
//       fontFamily: "Akkurat",
//       fontSize: "0.875rem",
//       color: "#000",
//     }}
//   >
//     Maturity Levels
//   </Typography>

//   {/* Maturity Levels List */}
//   <Box
//     sx={{
//       display: "flex",
//       flexDirection: "column",
//       gap: "0.75rem",
//       width: "100%",
//     }}
//   >

//     {/* --- 1. Managed --- */}
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: { xs: "column", sm: "row" }, // responsive
//         alignItems: { xs: "flex-start", sm: "center" },
//         gap: "0.5rem",
//         width: "100%",
//       }}
//     >
//     <Box
//   sx={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "0.25rem",                 // spacing/small-small
//     width: "4.6875rem",             // exact width
//     padding: "0.25rem 0.5rem",      // extra-small small-small
//     borderRadius: "0.25rem",
//     background: "#F5F6F8",
//     color: "#C89600",               // keep your text color
//     fontSize: "0.75rem",
//     fontFamily: "Akkurat",
//     textAlign: "center",
//   }}
// >
//   Managed
// </Box>

//       <Typography
//         sx={{
//           fontSize: "0.75rem",
//           color: "#000",
//           fontFamily: "Akkurat",
//         }}
//       >
//         Integrate continuous testing, chaos engineering, and validation pipelines to catch reliability
//         issues before they hit production.
//       </Typography>
//     </Box>

//     {/* --- 2. Optimized --- */}
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: { xs: "column", sm: "row" },
//         alignItems: { xs: "flex-start", sm: "center" },
//         gap: "0.5rem",
//         width: "100%",
//       }}
//     >
//          <Box
//   sx={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "0.25rem",                 // spacing/small-small
//     width: "4.6875rem",             // exact width
//     padding: "0.25rem 0.5rem",      // extra-small small-small
//     borderRadius: "0.25rem",
//     background: "#F5F6F8",
//     color: "#0F62FE",               // keep your text color
//     fontSize: "0.75rem",
//     fontFamily: "Akkurat",
//     textAlign: "center",
//   }}
// >
// Optimized
// </Box>

//       <Typography sx={{ fontSize: "0.75rem", color: "#000", fontFamily: "Akkurat" }}>
//         Integrate continuous testing, chaos engineering, and validation pipelines to catch reliability
//         issues before they hit production.
//       </Typography>
//     </Box>

//     {/* --- 3. Measured --- */}
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: { xs: "column", sm: "row" },
//         alignItems: { xs: "flex-start", sm: "center" },
//         gap: "0.5rem",
//         width: "100%",
//       }}
//     >
//       <Box
//   sx={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "0.25rem",                 // spacing/small-small
//     width: "4.6875rem",             // exact width
//     padding: "0.25rem 0.5rem",      // extra-small small-small
//     borderRadius: "0.25rem",
//     background: "#F5F6F8",
//     color: "#008200",               // keep your text color
//     fontSize: "0.75rem",
//     fontFamily: "Akkurat",
//     textAlign: "center",
//   }}
// >
// Measured
// </Box>

//       <Typography sx={{ fontSize: "0.75rem", color: "#000", fontFamily: "Akkurat" }}>
//         Integrate continuous testing, chaos engineering, and validation pipelines to catch reliability
//         issues before they hit production.
//       </Typography>
//     </Box>

//     {/* --- 4. Initial --- */}
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: { xs: "column", sm: "row" },
//         alignItems: { xs: "flex-start", sm: "center" },
//         gap: "0.5rem",
//         width: "100%",
//       }}
//     >
//      <Box
//   sx={{
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     gap: "0.25rem",                 // spacing/small-small
//     width: "4.6875rem",             // exact width
//     padding: "0.25rem 0.5rem",      // extra-small small-small
//     borderRadius: "0.25rem",
//     background: "#F5F6F8",
//     color: "#C71313",               // keep your text color
//     fontSize: "0.75rem",
//     fontFamily: "Akkurat",
//     textAlign: "center",
//   }}
// >
// Initial
// </Box>

//       <Typography sx={{ fontSize: "0.75rem", color: "#000", fontFamily: "Akkurat" }}>
//         Integrate continuous testing, chaos engineering, and validation pipelines to catch reliability
//         issues before they hit production.
//       </Typography>
//     </Box>

//   </Box>
// </Box>
//   )}

//   {/* Small Instruction Cards */}
//   {currentItems.map((item, index) => (
//     <Box
//       key={index}
//       sx={{
//         width: "97%",
//         borderRadius: "0.75rem",
//         border: "1px solid #D4D9E2",
//         background: "#FFFFFF",
//         padding: "0.75rem 1rem",
//         display: "flex",
//         alignItems: "center",
//         boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
//         "&:hover": { background: "#F7F9FF" },
//       }}
//     >
//       <Typography
//         sx={{
//           color: "#000",
//           fontSize: "0.75rem",
//           fontFamily: "Akkurat",
//           lineHeight: "normal",
//           pl: 1,
//         }}
//       >
//         {item.instruction}
//       </Typography>
//     </Box>
//   ))}

// </Box>

//           {/* Pagination + Go back */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "row",
//               alignItems: "center",
//               justifyContent: "space-between",
//               width: "100%",
//               mt: 1,
//             }}
//           >
//             <Box sx={{ flexGrow: 1, display: "flex",flexDirection:'column', justifyContent: "center",alignItems:'center',gap:2 }}>
//               <Pagination
//                 count={pageCount}
//                 page={page}
//                 onChange={handlePageChange}
//                 sx={{
//                   "& .MuiPaginationItem-root": { color: "#000", fontWeight: 400 },
//                   "& .Mui-selected": {
//                     backgroundColor: "transparent !important",
//                     color: "#000 !important",
//                     fontWeight: 500,
//                     position: "relative",
//                     "&::after": {
//                       content: '""',
//                       position: "absolute",
//                       bottom: "-4px",
//                       left: "50%",
//                       transform: "translateX(-50%)",
//                       width: "12px",
//                       borderBottom: "3px solid #000",
//                     },
//                   },
//                 }}
//               />

//             <Button
//               variant="contained"
//               sx={{
//                 width: { xs: "6rem", sm: "7rem", md: "7.5rem" },
//                 height: { xs: "2.3rem", sm: "2.25rem" },
//                 borderRadius: "1.75rem",
//                 background: "none",
//                 color: "#1F2D5C",
//                 border:'1px solid #1F2D5C',
//                 textTransform: "none",
//                 fontFamily:"Akkurat",
//                 fontWeight:400,
//                 fontSize: { xs: "0.75rem", sm: "0.85rem" },
//                 // "&:hover": { backgroundColor: "#0052cc" },
//               }}
//               onClick={() => navigate(-1)}
//             >
//               Back
//             </Button>
//             </Box>
//           </Box>
//         </Box>
//       )}
//     </Box>
//   );
// }

import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Pagination,
  CircularProgress,
  Paper,
} from "@mui/material";
// import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useNavigate } from "react-router-dom";
import { useApi } from "../api/useApi";

const ITEMS_PER_PAGE = 6;

export default function InstructionsCard() {
  const [page, setPage] = useState(1);
  const [instructionsData, setInstructionsData] = useState([]);
  const { loading, request } = useApi();
  const navigate = useNavigate();
  const pageCount = Math.ceil(instructionsData.length / ITEMS_PER_PAGE);

  useEffect(() => {
    async function fetchInstructions() {
      const data = await request({ url: "/tasks" });
      setInstructionsData(data);
    }
    fetchInstructions();
  }, []);

  const handlePageChange = (_, value) => setPage(value);

  const currentItems = instructionsData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE,
  );

  return (
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        width: "100%",
        // minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        overflow: "hidden",
        background: "#F5F6F8",
        pt: 1,
        // pt: { xs: "1rem", md: "2.5rem" },
      }}
    >
      {/* Loader */}
      {loading && instructionsData.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
            alignItems: "center",
            width: "100%",
            minHeight: "60vh",
          }}
        >
          <CircularProgress size={50} sx={{ color: "#0F62FE" }} />
        </Box>
      ) : (
        /* Main Card */
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: {
              xs: "92%",
              sm: "88%",
              md: "70v%",
              lg: "94%",
              xl: "97%",
            },

            height: {
              xs: "85vh",
              sm: "82vh",
              md: "80vh",
              lg: "78vh",
              xl: "90vh",
            },
            p: {
              xs: "1rem",
              sm: "1rem",
              md: "1rem",
              lg: "2rem 1rem",
              xl: "1rem",
            },
            borderRadius: "1.25rem",
            background: "#FFFFFF",
            border: "1px solid #DADADA",

            overflow: "hidden",
          }}
        >
          {/* Heading */}
          <Box
            sx={{
              width: "95%",
              padding: "0.75rem  1.5rem",
              borderBottom: "1px solid #D4D9E2",
              background: "#EDF0FD",
              mb: "1rem",
              borderRadius: "0.75rem",
            }}
          >
            <Typography
              sx={{
                color: "#0036DD",
                fontSize: "16px",
                fontWeight: 400,
                fontFamily: "Akkurat-Bold",
                pl: 1,
              }}
            >
              Instructions
            </Typography>
          </Box>

          {/* Scrollable Area */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              width: "100%",
              flex: 1,
              overflowY: "scroll",
              pr: "0.3rem",
              "&::-webkit-scrollbar": { display: "none" },
              scrollbarWidth: "none",
              msOverflowStyle: "none",
            }}
          >
            {/* Maturity Levels Box */}
            <>
              <Paper elevation={0}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: { xs: "0.75rem", md: "1rem" },
                    borderRadius: "0.5rem",
                    border: "1px solid #D5DBDE",
                    background: "#FFF",
                  }}
                >
                  <Typography sx={{ fontFamily:"Akkurat-Bold",fontWeight: 400,fontSize:'14px' }}>
                    How to Complete the Assessment
                  </Typography>
                  <Typography sx={{ fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px' }}>
                    To ensure accurate and meaningful results, please follow the
                    guidelines below:
                  </Typography>
                  {/* <Box component="ol"> */}
                  {[
                    "Answer based on current reality, not planned improvements.",
                    "Select the option that most closely represents your standard operating practice.",
                    "If practices vary across teams, answer based on the most common or production-critical systems.",
                    "Avoid aspirational responses — the value of this assessment depends on honesty.",
                    "The assessment typically takes 15–25 minutes to complete.",
                    "You may save progress and return later (if enabled).",
                    "All responses are treated as confidential and used solely for generating your maturity report.",
                  ].map((item, idx) => (
                    <Typography
                      // component="li"
                      variant="body2"
                      sx={{ marginLeft: "10px", lineHeight: "0.75",fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px' }}
                      key={idx}
                    >
                      {idx + 1}.{item}
                    </Typography>
                  ))}
                  {/* </Box> */}
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>Scoring Methodology</Typography>
                  {[
                    "Each question contributes to a weighted capability index",
                    "Scores are calculated across multiple dimensions.",
                    "Final output includes:",
                  ].map((item, idx) => (
                    <Typography
                      component="li"
                      variant="body2"
                      sx={{ marginLeft: "30px", lineHeight: "0.50",fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px' }}
                    >
                      {item}
                    </Typography>
                  ))}
                  {[
                    "Overall Maturity Score",
                    "DevOps Score",
                    "SRE Score",
                    "Domain-wise breakdown",
                    "Risk indicators",
                    "Recommended next steps",
                  ].map((item, idx) => (
                    <Typography
                      component="li"
                      variant="body2"
                      sx={{ marginLeft: "45px", lineHeight: "0.50" ,fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}
                      key={idx}
                    >
                      {item}
                    </Typography>
                  ))}
                </Box>
              </Paper>
              <Paper elevation={0}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: { xs: "0.75rem", md: "1rem" },
                    borderRadius: "0.5rem",
                    border: "1px solid #D5DBDE",
                    background: "#FFF",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Akkurat-Bold",
                      fontWeight: 400,
                      fontSize: "14px",
                    }}
                  >
                    DevOps & SRE Maturity Compass
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Akkurat",
                      fontWeight: 400,
                      fontSize: "12px",
                    }}
                  >
                    Modern software delivery is no longer just about shipping
                    features — it’s about delivering value reliably, securely,
                    and at scale.
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: "Akkurat",
                      fontWeight: 400,
                      fontSize: "12px",
                    }}
                  >
                    The DevOps & SRE Maturity Compass is a structured assessment
                    portal designed to evaluate your organization's current
                    DevOps and Site Reliability Engineering practices.By
                    answering a series of targeted, experience-driven questions,
                    you will receive:
                  </Typography>
                  {[
                    "A quantified maturity score",
                    "Category-wise performance breakdown",
                    "Risk and gap analysis",
                    "Actionable improvement recommendations",
                    "A downloadable executive report",
                  ].map((item, idx) => (
                    <Typography
                      component="li"
                      variant="body2"
                      sx={{
                        marginLeft: "30px",
                        lineHeight: "0.50",
                        fontFamily: "Akkurat",
                        fontWeight: 400,
                        fontSize: "12px",
                      }}
                      key={idx}
                    >
                      {item}
                    </Typography>
                  ))}
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    This assessment helps engineering leaders, architects,
                    DevOps engineers, and SRE teams understand where they stand
                    today and what it will take to move toward operational
                    excellence.
                  </Typography>
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>

                    Whether you are early in your DevOps journey or operating
                    complex distributed systems, this assessment provides
                    clarity, benchmarking, and a practical roadmap forward.
                  </Typography>
                </Box>
              </Paper>
              <Paper elevation={0}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: { xs: "0.75rem", md: "1rem" },
                    borderRadius: "0.5rem",
                    border: "1px solid #D5DBDE",
                    background: "#FFF",
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontFamily:"Akkurat-Bold",fontWeight: 600,fontSize:'14px' }}>
                    DevOps Maturity Assessment{" "}
                  </Typography>
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    The DevOps Assessment evaluates how effectively your
                    organization integrates development and operations practices
                    to deliver software rapidly, reliably, and securely.
                  </Typography>
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    This section focuses on key capability areas including:
                  </Typography>
                  {[
                    "Continuous Integration & Continuous Delivery (CI/CD)",
                    "Infrastructure as Code (IaC)",
                    "Security integration (DevSecOps)",
                    "Monitoring & Observability",
                    "Operational Tooling",
                    "Reporting & Compliance",
                  ].map((item, idx) => (
                    <Typography
                      component="li"
                      sx={{ marginLeft: "30px", lineHeight: "0.50" ,fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}
                      key={idx}
                    >
                      {item}
                    </Typography>
                  ))}
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>The objective is to measure:</Typography>
                  {[
                    "Delivery speed and predictability",
                    "Deployment frequency and lead time",
                    "Change failure rate",
                    "Recovery processes",
                    "Level of automation vs. manual intervention",
                  ].map((item, idx) => (
                    <Typography
                      component="li"
                      variant="body2"
                      sx={{ marginLeft: "30px", lineHeight: "0.50",fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px' }}
                      key={idx}
                    >
                      {item}
                    </Typography>
                  ))}
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    Your responses will help identify bottlenecks, operational
                    risks, process inefficiencies, and opportunities for
                    automation and standardization.
                  </Typography>
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    The final DevOps score reflects your current delivery
                    maturity level and readiness for scalable, cloud-native, and
                    high-velocity engineering.
                  </Typography>
                </Box>
              </Paper>
              <Paper elevation={0}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    padding: { xs: "0.75rem", md: "1rem" },
                    borderRadius: "0.5rem",
                    border: "1px solid #D5DBDE",
                    background: "#FFF",
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontFamily:"Akkurat-Bold",fontWeight: 600,fontSize:'14px' }}>
                    {" "}
                    Site Reliability Engineering (SRE) Assessment{" "}
                  </Typography>

                  <Typography variant="subtitle1" sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    The SRE Assessment measures the reliability, scalability,
                    resilience, and observability posture of your production
                    systems.
                  </Typography>
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    Inspired by industry-proven reliability engineering
                    practices pioneered at companies like Google, this
                    assessment evaluates how well your systems balance
                    innovation velocity with operational stability.
                  </Typography>
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>The SRE assessment covers:</Typography>
                  {[
                    "Service Level Objectives (SLOs) & Service Level Indicators (SLIs)",
                    "Error budgets and reliability governance",
                    "Monitoring & observability practices",
                    "Security",
                    "Monitoring & Observability",
                    "Operational Tooling",
                    "Reporting & Compliance",
                  ].map((item, idx) => (
                    <Typography
                      component="li"
                      variant="body2"
                      sx={{ marginLeft: "30px", lineHeight: "0.50",fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px' }}
                      key={idx}
                    >
                      {item}
                    </Typography>
                  ))}
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>This assessment helps determine:</Typography>
                  {[
                    "How measurable your reliability targets are",
                    "How effectively incidents are detected and mitigated",
                    "Whether reliability is engineered or reactive",
                    "The sustainability of your operational model",
                  ].map((item, idx) => (
                    <Typography
                      component="li"
                      variant="body2"
                      sx={{ marginLeft: "30px", lineHeight: "0.50",fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px' }}
                      key={idx}
                    >
                      {item}
                    </Typography>
                  ))}
                  <Typography sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'12px'}}>
                    Your SRE score reflects the robustness of your production
                    systems and your organization’s ability to scale without
                    compromising availability or customer trust.
                  </Typography>
                </Box>
              </Paper>
            </>
            <Box
              sx={{
                width: "95%",
                padding: "0.75rem  1.5rem",
                borderBottom: "1px solid #D4D9E2",
                background: "#EDF0FD",
                mb: "1rem",
                borderRadius: "0.75rem",
              }}
            >
              <Typography
                sx={{
                  color: "#0036DD",
                  fontSize: "16px",
                  fontWeight: 400,
                  fontFamily: "Akkurat-Bold",
                  pl: 1,
                }}
              >
                Instructions
              </Typography>
              <Typography
                sx={{fontFamily:"Akkurat",fontWeight: 400,fontSize:'13px',pl:1}}
              >
                This portal help assess Maturity levels of an organizations as
                per below defined criteria.
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                padding: { xs: "0.75rem", md: "1rem" },
                borderRadius: "0.5rem",
                border: "1px solid #D5DBDE",
                background: "#FFF",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Akkurat",
                  fontSize: "14px",
                  color: "#000",
                  fontWeight:400,
                  pl: 1,
                }}
              >
                Maturity Levels
              </Typography>

              {/* Maturity Levels List */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.75rem",
                  width: "100%",
                }}
              >
                {/* --- 1. Optimized --- */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    gap: "0.5rem",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.25rem", // spacing/small-small
                      width: "4.6875rem", // exact width
                      padding: "0.25rem 0.5rem", // extra-small small-small
                      borderRadius: "0.25rem",
                      background: "#F5F6F8",
                      color: "#0F62FE", // keep your text color
                      fontSize: "12px",
                      fontFamily: "Akkurat",
                      textAlign: "center",
                      fontWeight:400
                    }}
                  >
                    Optimized
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#000",
                      fontFamily: "Akkurat",
                      fontWeight:400
                    }}
                  >
                    The system operates with peak efficiency, leveraging
                    advanced DevOps methodologies and continuous security
                    compliance.
                  </Typography>
                </Box>

                {/* --- 2. Measured --- */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    gap: "0.5rem",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.25rem", // spacing/small-small
                      width: "4.6875rem", // exact width
                      padding: "0.25rem 0.5rem", // extra-small small-small
                      borderRadius: "0.25rem",
                      background: "#F5F6F8",
                      color: "#008200", // keep your text color
                      fontSize: "12px",
                      fontFamily: "Akkurat",
                      textAlign: "center",
                      fontWeight:400
                    }}
                  >
                    Measured
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#000",
                      fontFamily: "Akkurat",
                      fontWeight:400
                    }}
                  >
                    Industry best practices are integrated with robust tooling
                    and telemetry, enabling objective performance tracking.
                  </Typography>
                </Box>

                {/* --- 3. Managed --- */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" }, // responsive
                    alignItems: { xs: "flex-start", sm: "center" },
                    gap: "0.5rem",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.25rem", // spacing/small-small
                      width: "4.6875rem", // exact width
                      padding: "0.25rem 0.5rem", // extra-small small-small
                      borderRadius: "0.25rem",
                      background: "#F5F6F8",
                      color: "#C89600", // keep your text color
                      fontSize: "12px",
                      fontFamily: "Akkurat",
                      textAlign: "center",
                      fontWeight:400
                    }}
                  >
                    Managed
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#000",
                      fontFamily: "Akkurat",
                      fontWeight:400
                    }}
                  >
                    Core best practices are present, but execution is
                    inconsistent and requires structural maturity to scale.
                  </Typography>
                </Box>

                {/* --- 4. Initial --- */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    gap: "0.5rem",
                    width: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "0.25rem", // spacing/small-small
                      width: "4.6875rem", // exact width
                      padding: "0.25rem 0.5rem", // extra-small small-small
                      borderRadius: "0.25rem",
                      background: "#F5F6F8",
                      color: "#C71313", // keep your text color
                      fontSize: "12px",
                      fontFamily: "Akkurat",
                      textAlign: "center",
                      fontWeight:400
                    }}
                  >
                    Initial
                  </Box>

                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: "#000",
                      fontFamily: "Akkurat",
                      fontWeight:400
                    }}
                  >
                    The environment lacks alignment with DevSecOps best
                    practices, resulting in manual bottlenecks and high
                    operational risk.
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Small Instruction Cards */}
            {/* {currentItems.map((item, index) => (
    <Box
      key={index}
      sx={{
        width: "97%",
        borderRadius: "0.75rem",
        border: "1px solid #D4D9E2",
        background: "#FFFFFF",
        padding: "0.75rem 1rem",
        display: "flex",
        alignItems: "center",
        boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
        "&:hover": { background: "#F7F9FF" },
      }}
    >
      <Typography
        sx={{
          color: "#000",
          fontSize: "0.75rem",
          fontFamily: "Akkurat",
          lineHeight: "normal",
          pl: 1,
        }}
      >
        {item.instruction}
      </Typography>
    </Box>
  ))} */}
          </Box>

          {/* Pagination + Go back */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              mt: 1,
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
              }}
            >
              {/* <Pagination
  count={pageCount}
  page={page}
  onChange={handlePageChange}
  renderItem={(item) => (
    <PaginationItem
      {...item}
      slots={{
        previous: () => (
          <PlayArrowIcon
            sx={{ transform: "rotate(180deg)", fontSize: 20 }}
          />
        ),
        next: () => <PlayArrowIcon sx={{ fontSize: 20 }} />,
      }}
    />
  )}
  sx={{
    "& .MuiPaginationItem-root": {
      color: "#000",
      fontWeight: 400,
    },
    "& .Mui-selected": {
      backgroundColor: "transparent !important",
      color: "#000 !important",
      fontWeight: 500,
      position: "relative",
      "&::after": {
        content: '""',
        position: "absolute",
        bottom: "-4px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "12px",
        borderBottom: "3px solid #000",
      },
    },
  }}
/> */}

              <Button
                variant="contained"
                sx={{
                  width: { xs: "6rem", sm: "7rem", md: "7.5rem" },
                  height: { xs: "2.3rem", sm: "2.25rem" },
                  borderRadius: "1.75rem",
                  background: "none",
                  color: "#1F2D5C",
                  border: "1px solid #1F2D5C",
                  textTransform: "none",
                  fontFamily: "Akkurat",
                  fontWeight: 400,
                  fontSize: { xs: "0.75rem", sm: "0.85rem" },
                  // "&:hover": { backgroundColor: "#0052cc" },
                }}
                onClick={() => navigate(-1)}
              >
                Back
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
}
